exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#footer[data-v-01a564cb]{width:100%;height:90px;background-color:rgba(43,43,43,.8);position:fixed;left:0;bottom:0;z-index:30}#footer a[data-v-01a564cb]{width:25%;height:100%;float:left;color:#fff;text-align:center;padding-top:21px;font:500 1.6rem/1.5 Nanum Gothic,sans-serif}#footer a span[data-v-01a564cb]{display:flex;justify-content:center;align-items:center;width:100%;height:36px}#footer a span img[data-v-01a564cb]{height:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01a564cb","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/component/Footer.vue
// module id = 45
// module chunks = 0